import * as React from 'react'
import { Query } from '../apollo/Query'

export const withQuery = (Component, query, additionalProps: any = {}) => (
  props
) => <Query query={query} component={Component} {...props} {...additionalProps} />
